import type { TFunction } from 'i18next'

export const REFUND_DEADLINE_DAYS_OPTIONS = [7, 15, 30, 60, 90] as const
export const REFUND_DEADLINE_DAYS_OPTIONS_PHYSICAL = [30, 60, 90] as const

export type RefundDeadlineDays = (typeof REFUND_DEADLINE_DAYS_OPTIONS)[number]

export const MIN_REFUND_DEADLINE_DAYS = 7
export const MAX_REFUND_DEADLINE_DAYS = 90

function isPhysicalLike(productType?: string | null): boolean {
  const type = (productType || '').toLowerCase()
  return type === 'physical' || type === 'pharmaceutical'
}

export function refundDeadlineDaysOptionsForType(
  productType?: string | null,
): readonly number[] {
  return isPhysicalLike(productType)
    ? REFUND_DEADLINE_DAYS_OPTIONS_PHYSICAL
    : REFUND_DEADLINE_DAYS_OPTIONS
}

export function defaultRefundDeadlineDays(productType?: string | null): RefundDeadlineDays {
  return isPhysicalLike(productType) ? 30 : 7
}

export function isAllowedRefundDeadlineDays(
  value: unknown,
  productType?: string | null,
): value is RefundDeadlineDays {
  return refundDeadlineDaysOptionsForType(productType).includes(Number(value))
}

export function normalizeRefundDeadlineDays(
  value: unknown,
  productType?: string | null,
): RefundDeadlineDays {
  if (isAllowedRefundDeadlineDays(value, productType)) {
    return Number(value) as RefundDeadlineDays
  }

  return defaultRefundDeadlineDays(productType)
}

export function getRefundDeadlineDaysSelectOptions(
  t: TFunction,
  productType?: string | null,
) {
  return refundDeadlineDaysOptionsForType(productType).map((days) => ({
    value: String(days),
    label: t('refundDeadlineDaysOption', { days }),
  }))
}
